import { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { ChevronDown, Menu, X, ArrowUpRight } from "lucide-react";
import { Logo, GradButton, GhostButton } from "./LoansUi";
import { LoansProvider, useLoans } from "./LoansContext";

const NAV = [
  { to: "/lenders", label: "Lenders", id: "lenders" },
  { to: "/emi-calculator", label: "EMI Calculator", id: "emi" },
];
const linkCls = ({ isActive }) => `text-[15px] font-medium transition-colors ${isActive ? "text-[#0FA37F]" : "text-[#0B1B3F] hover:text-[#0FA37F]"}`;

function ProductsMenu() {
  return (
    <div className="relative group">
      <button data-testid="le-nav-products" className="flex items-center gap-1 text-[15px] font-medium text-[#0B1B3F] group-hover:text-[#0FA37F]">
        Loan Products <ChevronDown className="w-4 h-4" />
      </button>
      <div className="absolute left-0 top-full pt-3 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity">
        <Link to="/personal-loan" data-testid="le-nav-personal-loan" className="block w-52 rounded-xl bg-white border border-slate-100 shadow-xl px-4 py-3 text-sm font-medium text-[#0B1B3F] hover:text-[#0FA37F]">
          Personal Loan
        </Link>
      </div>
    </div>
  );
}

function Header() {
  const nav = useNavigate();
  const { products, apply } = useLoans();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-[76px] flex items-center justify-between gap-6">
        <Logo />
        <nav className="hidden lg:flex items-center gap-10">
          <ProductsMenu />
          {NAV.map((n) => <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`le-nav-${n.id}`}>{n.label}</NavLink>)}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <GhostButton data-testid="le-header-eligibility" onClick={() => nav("/check-eligibility")} className="h-11 px-5 rounded-full">Check Eligibility</GhostButton>
          <GradButton data-testid="le-header-apply" onClick={() => apply(products[0])} className="h-11 px-6 rounded-full">Apply Now</GradButton>
        </div>
        <button data-testid="le-mobile-menu" className="lg:hidden p-2 text-[#0B1B3F]" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white px-5 py-4 flex flex-col gap-4" onClick={() => setOpen(false)}>
          <NavLink to="/personal-loan" className={linkCls} data-testid="le-m-nav-personal-loan">Personal Loan</NavLink>
          {NAV.map((n) => <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`le-m-nav-${n.id}`}>{n.label}</NavLink>)}
          <NavLink to="/check-eligibility" className={linkCls} data-testid="le-m-nav-eligibility">Check Eligibility</NavLink>
          <GradButton data-testid="le-m-apply" onClick={() => apply(products[0])} className="h-11 rounded-full">Apply Now</GradButton>
        </div>
      )}
    </header>
  );
}

function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-10 flex flex-wrap items-center justify-between gap-6 text-sm text-[#4B5B7C]">
        <Logo />
        <div className="flex flex-wrap gap-6">
          <Link to="/personal-loan" className="hover:text-[#0B1B3F]">Personal Loan</Link>
          <Link to="/lenders" className="hover:text-[#0B1B3F]">Lenders</Link>
          <Link to="/emi-calculator" className="hover:text-[#0B1B3F]">EMI Calculator</Link>
          <a href="https://offer.express" className="hover:text-[#0B1B3F] inline-flex items-center gap-1">Offer Express <ArrowUpRight className="w-3.5 h-3.5" /></a>
        </div>
        <div className="w-full text-xs text-slate-400">© {new Date().getFullYear()} Offer Express · loanexpress. Rates and amounts are indicative and set by each lender.</div>
      </div>
    </footer>
  );
}

export default function LoansLayout() {
  return (
    <LoansProvider>
      <div className="le-root min-h-screen bg-[#F7F9FC] text-[#0B1B3F] relative overflow-x-hidden">
        <div aria-hidden className="le-wave" />
        <Header />
        <main className="relative z-[1]"><Outlet /></main>
        <Footer />
      </div>
    </LoansProvider>
  );
}
